import axiosInstance from "../axiosInstance";

export const commandCenterService = {
  // The client's precomputed attention snapshot ({ status: "building" } until the first one exists).
  fetch: async (params, { signal } = {}) => {
    const response = await axiosInstance.get("/command-center", { params, signal, suppressErrorToast: true });
    return response.data;
  },
  // Ask for a rebuild now; answers { started, refreshing, reason } (reason "cooldown" when too soon).
  refresh: async (data) => {
    const response = await axiosInstance.post("/command-center", data || {}, { suppressErrorToast: true });
    return response.data;
  },
};
